export default __webpack_public_path__ + "static/media/none.accab56e.png";